@if (showLoading) {
    <p-skeleton></p-skeleton>
} @else {
    @let tag =
        _isWaitingForInput ? ServiceRequestUtils.waitingForInputTag : ServiceRequestUtils.statusTagsByStatus[_status!];
    <p-tag
        [pTooltip]="tag.tooltip"
        [value]="tag.label"
        [rounded]="false"
        [style]="tag.style!"
        [styleClass]="tag.styleClass"
    >
        <i [class]="tag.icon" [ngStyle]="tag.iconStyle"></i>
    </p-tag>
}
